<template>
    <Head :title="translate('headline')"></Head>

    <div class="relative py-16 bg-white overflow-hidden mx-auto max-w-7xl">
        <div class="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
            <div class="relative h-full text-lg max-w-prose mx-auto" aria-hidden="true">

                <svg class="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                    <defs>
                        <pattern id="f210dbf6-a58d-4871-961e-36d5016a0f49" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                        </pattern>
                    </defs>
                    <rect width="404" height="384" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
                </svg>
                <svg class="absolute bottom-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                    <defs>
                        <pattern id="d3eb07ae-5182-43e6-857d-35c643af9034" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                        </pattern>
                    </defs>
                    <rect width="404" height="384" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
                </svg>
            </div>
        </div>
        <div class="relative px-4 sm:px-6 lg:px-8">
            <div class="text-lg max-w-prose mx-auto">
                <h1>
                    <span class="block text-base text-center text-indigo-600 font-semibold tracking-wide uppercase">web3register.org</span>
                    <span class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">{{ translate('headline') }}</span>
                </h1>
                <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-1 mt-8">
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('operator') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">Foundervision GmbH</dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('office') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">Cho d'Punt 10<br />7503 Samedan (Schweiz)</dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('director') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">René Wendler (einzelvertretungsberechtigt)</dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('email') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">service@web3register.org</dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('salesTaxId') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">CHE-360.493.116.</dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('registerNo') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">
                            CH-400.4.441.959-9<br />
                            Register Samedan (vormals Zug)
                        </dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('registerDate') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">12.12.2016</dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">{{ translate('purpose') }}</dt>
                        <dd class="mt-1 text-sm text-gray-900">{{ translate('purposeContent') }}</dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, usePage} from '@inertiajs/inertia-vue3'
import translate from '../../lang';

export default {
    components: {
        Head
    },
    setup() {
        return {translate: translate('imprint')}
    }
}
</script>
